export const QUEUE_WAIT_TIME = 1000;
export const MAX_BATCH_SIZE = 5;
